module.exports = __webpack_public_path__ + "img/Ad-Banner-slide-4.e6b1206b.jpg";